import fieldType from '@/enums/fieldType'
import vuei18n from '@/plugins/vuei18n'
import SchemaType from "@/enums/schemaType"


export default {
  validators: {
    requiredValidator: v => !!v,
    minLengthValidator: (v, min) => !!v && v.length >= min,
    maxLengthValidator: (v, max) => !!v && v.length <= max,
    minValidator: (v, min) => !!v && Number(v) >= min,
    maxValidator: (v, max) => !!v && Number(v) <= max
  },
  check (value, field, formType) {
    if (field.options == undefined || field.options == null) {
      return { pass: true, message: '' }
    }
    if (field.options.required && !this.validators.requiredValidator(value)) {
      return { pass: false, message: vuei18n.t('validator.required') }
    }
    if (field.type === fieldType.RADIO && formType == SchemaType.TEST &&  field.options.answer != value){
      return this.validateRadioTest(value, field)
    }
    if (field.type === fieldType.TEXT) {
      if (field.options.minLength && !this.validators.minLengthValidator(value, field.options.minLength)) {
        return { pass: false, message: vuei18n.t('validator.minLength', { minLength: field.options.minLength }) }
      }
      if (field.options.maxLength && !this.validators.maxLengthValidator(value, field.options.maxLength)) {
        return { pass: false, message: vuei18n.t('validator.maxLength', { maxLength: field.options.maxLength }) }
      }
    }
    if (field.type === fieldType.NUMBER) {
      if (field.options.min && !this.validators.minValidator(value, field.options.min)) {
        return { pass: false, message: vuei18n.t('validator.min', { min: field.options.min }) }
      }
      if (field.options.max && !this.validators.maxValidator(value, field.options.max)) {
        return { pass: false, message: vuei18n.t('validator.max', { max: field.options.max }) }
      }
    }
    return { pass: true, message: '' }
  },
  validateRadioTest(value, field){
    let correct = field.values.find(el => el.key == field.options.answer)
    if(correct == null){
      return { pass: true, message: vuei18n.t('test.unkown_answer')}
    }

    return { pass: false, message: vuei18n.t('test.bad_answer') + correct.value }
  }
}
